import { render, staticRenderFns } from "./ModalAddNewFormItem.vue?vue&type=template&id=16acb9f9"
import script from "./ModalAddNewFormItem.vue?vue&type=script&lang=js"
export * from "./ModalAddNewFormItem.vue?vue&type=script&lang=js"
import style0 from "./ModalAddNewFormItem.vue?vue&type=style&index=0&id=16acb9f9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports